import { render, staticRenderFns } from "./MyReviewsAssigned.vue?vue&type=template&id=30cc9cce"
import script from "./MyReviewsAssigned.vue?vue&type=script&lang=js"
export * from "./MyReviewsAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports